import { Typography } from '@mui/material';
import { CalculusAreaAccordionDetails } from '../CalculusAreaAccordionDetails';
import { MarkupCondition } from '@retail/calculus/types';
import { useMarkupTFunction } from '@retail/markup/i18n';
import { EditableFieldValueView } from './EditableFieldValueView';
import { useTranslation } from 'react-i18next';
import { MarkupChange } from '../../store';
import { SalesFactorInput } from './InputFields';

interface Props {
  markupCondition?: MarkupCondition;
  markupFactor?: number;
  editFactorDisabled: boolean;
  editFactor: boolean;
  newMarkup?: MarkupChange;
  setEditingFieldToFactor?: () => void;
  setSalesFactor: (factor: number) => void;
  resetMarkup: () => void;
}

export function MarkupAccordionDetails({
  markupCondition,
  markupFactor,
  editFactorDisabled,
  editFactor,
  newMarkup,
  setEditingFieldToFactor,
  setSalesFactor,
  resetMarkup,
}: Props) {
  const t = useMarkupTFunction();
  const {
    i18n: { language },
  } = useTranslation();

  return markupCondition ? (
    <CalculusAreaAccordionDetails
      bindingType={markupCondition.bindingType}
      conditionValueDesc={t('markup.salesFactor')}
      conditionValue={
        editFactor ? (
          <SalesFactorInput
            defaultValue={markupFactor ?? 0}
            onSubmit={setSalesFactor}
            onCancel={resetMarkup}
          />
        ) : (
          <EditableFieldValueView
            currentValue={
              markupFactor
                ? markupFactor.toLocaleString(language, { maximumFractionDigits: 6 })
                : '-'
            }
            newValue={
              newMarkup?.salesFactor
                ? newMarkup.salesFactor.toLocaleString(language, { maximumFractionDigits: 6 })
                : undefined
            }
            isApproximate={newMarkup?.editedField !== 'factor'}
            openEditMode={setEditingFieldToFactor}
            disabled={editFactorDisabled}
          />
        )
      }
      validFrom={markupCondition.validFrom}
      validTo={markupCondition.validTo}
    />
  ) : (
    <Typography variant="body2" sx={{ pl: 2 }}>
      {t('markup.noMarkups')}
    </Typography>
  );
}
